enum LineItemType {
  Default = 'default',
  Deposit = 'deposit',
  Discount = 'discount',
  Coupon = 'coupon',
}

export default LineItemType;
